var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatCheckFilled = function SvgChatCheckFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    fillRule: "evenodd",
    d: "M1.333 8a6.667 6.667 0 1 1 5.726 6.6h-.002a252.784 252.784 0 0 0-1.235-.17l-.022-.002h-.007l-.002-.001-.093-.007a.364.364 0 0 0-.02-.002h-.02l-.092.001c-.08 0-.175.007-.426.025l-1.46.105c-.265.018-.504.036-.702.033a1.6 1.6 0 0 1-.678-.138 1.567 1.567 0 0 1-.744-.744 1.6 1.6 0 0 1-.138-.678 8.774 8.774 0 0 1 .033-.701l.105-1.461c.018-.251.024-.346.025-.426v-.133l-.008-.092v-.003l-.001-.006-.002-.022A6.719 6.719 0 0 1 1.333 8Zm9.308-.67a.667.667 0 1 0-.751-1.1 10.657 10.657 0 0 0-2.783 2.778l-.97-.969a.667.667 0 1 0-.942.944l1.561 1.559a.667.667 0 0 0 1.05-.141 9.323 9.323 0 0 1 2.835-3.07Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatCheckFilled);
export default ForwardRef;